import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppEnums';
import {catalogAttributesConfig} from './attributes';
import CreateProductTag from './product-tags/create-product-tag';
import ProductRejectionReasons from './product-rejection-reasons';
import CreateOrUpdateRejectionReasons from './product-rejection-reasons/create-or-update';

const ProductsList = React.lazy(() => import('./products'));
const CreateProduct = React.lazy(() => import('./products/create-product'));
const ProductDetails = React.lazy(() => import('./products/product-details'));
const CategoriesList = React.lazy(() => import('./categories'));
const ProductReviews = React.lazy(() => import('./product-reviews'));
const UpdateReview = React.lazy(
  () => import('./product-reviews/update-review'),
);
const ProductTags = React.lazy(() => import('./product-tags'));
const CreateCategory = React.lazy(() => import('./categories/create-category'));

export const catalogConfig = [
  ...catalogAttributesConfig,
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/products',
    element: <ProductsList />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/products/add-product',
    element: <CreateProduct />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/products/edit/:id',
    element: <CreateProduct />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/products/details/:id',
    element: <ProductDetails />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/categories',
    element: <CategoriesList />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-reviews',
    element: <ProductReviews />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-reviews/details/:id',
    element: <UpdateReview />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-tags',
    element: <ProductTags />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-tags/create-product-tag',
    element: <CreateProductTag />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-tags/edit-product-tag/:id',
    element: <CreateProductTag />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/categories/create-category',
    element: <CreateCategory />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/categories/edit-category/:id',
    element: <CreateCategory />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-rejection-reasons',
    element: <ProductRejectionReasons />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-rejection-reasons/create',
    element: <CreateOrUpdateRejectionReasons />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/catalog/product-rejection-reasons/edit/:id',
    element: <CreateOrUpdateRejectionReasons />,
  },
];
